import $ from "jquery";
import { Klass, u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";

/****************************************
* define Klass VuwMinimalCalendarHeader *
****************************************/
vuwer.appendKlass("VuwMinimalCalendarHeader", {
	classPrefix: "",
	prevText: "",
	nextText: "",
	
	_initialize(opt) {
		const _super_ = Klass("VuwMinimalCalendarHeader").parent._initialize.bind(this);
		if( !_super_(opt) ) {
			return false;
		}
		
		// [add onReady callback]
		this._onReadyCallbacks.unshift(this._onReadyDefault);
		
		// [add onChangeState callback]
		this._onChangeStateCallbacks.unshift(this._onChangeStateDefault);
		
		return this;
	},
	
	selector() {
		if(this.container && this.container.$self) {
			return $("<ul/>").addClass(`${this.classPrefix}header`).appendTo(
				this.container.$self
			);
		}
	},
	
	_onReadyDefault($self) {
		if(!$self) {
			return false;
		}
		
		// [prev]
		const $prev = $("<li/>").addClass(`${this.classPrefix}prev`);
		if( this.prevText && u_.isString(this.prevText) ) {
			$("<a/>").html(
				$.parseHTML(this.prevText)
			).attr("href", "./").appendTo($prev);
		}
		
		// [caption]
		const $year = $("<span/>").addClass(`${this.classPrefix}year`);
		const $month = $("<span/>").addClass(`${this.classPrefix}month`);
		const $caption = $("<li/>").addClass(`${this.classPrefix}caption`).append(
			$year, $month
		);
		this.setProp({ $year, $month });
		
		// [next]
		const $next = $("<li/>").addClass(`${this.classPrefix}next`);
		if( this.nextText && u_.isString(this.nextText) ) {
			$("<a/>").html(
				$.parseHTML(this.nextText)
			).attr("href", "./").appendTo($next);
		}
		
		$self.append($prev, $caption, $next);
	},
	
	_onChangeStateDefault(state) {
		const { year, month } = state;
		u_.isString(year) && this.$year.text(year);
		u_.isString(month) && this.$month.text(month);
	}
});
